<template>
    <div class="contactus-page">
        <page-hero
            title="Επικοινωνία"
            eyebrow="The League"
            subtitle="Για εγγραφές, απορίες και ό,τι άλλο χρειαστείς"
            compact
        />
        <div class="cl-page">
            <div class="contact-layout">
                <!-- how to reach us: every row is a link (call, mail, map) -->
                <section class="contact-card">
                    <header class="contact-card__head">
                        <v-icon color="#03e5b7">mdi-message-text-outline</v-icon>
                        <span>Στοιχεία επικοινωνίας</span>
                    </header>

                    <div class="contact-group">
                        <div class="contact-group__label">Τηλέφωνα</div>
                        <a v-for="phone in phones" :key="phone" :href="`tel:${phone}`" class="contact-row">
                            <span class="contact-row__icon"><v-icon small color="white">mdi-phone</v-icon></span>
                            <span class="contact-row__text">
                                <span class="contact-row__label">Κινητό</span>
                                <span class="contact-row__value">{{ formatPhone(phone) }}</span>
                            </span>
                            <v-icon small class="contact-row__go">mdi-arrow-right</v-icon>
                        </a>
                    </div>

                    <div class="contact-group">
                        <div class="contact-group__label">Email</div>
                        <a v-for="email in emails" :key="email" :href="`mailto:${email}`" class="contact-row">
                            <span class="contact-row__icon"><v-icon small color="white">mdi-email-outline</v-icon></span>
                            <span class="contact-row__text">
                                <span class="contact-row__label">Email</span>
                                <span class="contact-row__value">{{ email }}</span>
                            </span>
                            <v-icon small class="contact-row__go">mdi-arrow-right</v-icon>
                        </a>
                    </div>

                    <div class="contact-group">
                        <div class="contact-group__label">Διεύθυνση</div>
                        <a :href="mapUrl" target="_blank" rel="noopener noreferrer" class="contact-row">
                            <span class="contact-row__icon"><v-icon small color="white">mdi-map-marker-outline</v-icon></span>
                            <span class="contact-row__text">
                                <span class="contact-row__label">Γραφεία</span>
                                <span class="contact-row__value">Μενελάου 15α, 141 22 Ν. Ηράκλειο Αττικής</span>
                            </span>
                            <v-icon small class="contact-row__go">mdi-open-in-new</v-icon>
                        </a>
                    </div>
                </section>

                <aside class="contact-aside">
                    <!-- the company -->
                    <section class="company-card">
                        <img :src="require('@/assets/main_logo.png')" alt="" class="company-card__logo">
                        <div class="company-card__name">Commercial League ΕΕ</div>
                        <div class="company-card__activity">Αθλητικές δραστηριότητες</div>
                        <dl class="company-card__facts">
                            <div>
                                <dt>ΑΦΜ</dt>
                                <dd>802999726</dd>
                            </div>
                            <div>
                                <dt>ΔΟΥ</dt>
                                <dd>ΚΕΦΟΔΕ Αττικής</dd>
                            </div>
                            <div>
                                <dt>ΓΕΜΗ</dt>
                                <dd>187097501000</dd>
                            </div>
                        </dl>
                    </section>

                    <!-- where people usually go next -->
                    <section class="contact-links">
                        <router-link :to="{ name: 'Register' }" class="contact-link contact-link--primary">
                            <v-icon small>mdi-account-plus-outline</v-icon>
                            Εγγραφή ομάδας
                            <v-icon small class="contact-link__go">mdi-arrow-right</v-icon>
                        </router-link>
                        <router-link :to="{ name: 'Regulations' }" class="contact-link">
                            <v-icon small>mdi-gavel</v-icon>
                            Κανονισμός
                            <v-icon small class="contact-link__go">mdi-arrow-right</v-icon>
                        </router-link>
                    </section>

                    <div class="contact-socials">
                        <button v-for="social in socials" :key="social.key" type="button" class="contact-social" :title="social.key" @click="openSocial(social.key)">
                            <v-icon small>{{ social.icon }}</v-icon>
                        </button>
                    </div>
                </aside>
            </div>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import { openSocial } from '@/utils/social'

    export default {
        components: { PageHero },
        data() {
            return {
                phones: ['+306973317561', '+306972901611'],
                emails: ['elias.alexiou@commercial-league.gr', 'i.mertyris@commercial-league.gr'],
                mapUrl: 'https://www.google.com/maps/place/Menelaou+15,+Iraklio+141+22/@38.051379,23.7545482,17z/data=!3m1!4b1!4m6!3m5!1s0x14a1a20c0ba09cd1:0x187851f32e362fae!8m2!3d38.0513748!4d23.7571231!16s%2Fg%2F11csgbr6vw?authuser=0&entry=ttu&g_ep=EgoyMDI1MTEwNC4xIKXMDSoASAFQAw%3D%3D',
                socials: [
                    { key: 'facebook', icon: 'mdi-facebook' },
                    { key: 'instagram', icon: 'mdi-instagram' },
                    { key: 'youtube', icon: 'mdi-youtube' },
                    { key: 'twitter', icon: 'mdi-twitter' },
                    { key: 'linkedin', icon: 'mdi-linkedin' }
                ]
            }
        },
        methods: {
            openSocial,
            // +306973317561 -> 697 331 7561
            formatPhone(phone) {
                return phone.replace(/^\+30(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3')
            }
        }
    }
</script>

<style scoped>
.contact-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
    gap: 24px;
    align-items: start;
    max-width: 1080px;
    margin: 0 auto;
    font-family: Roboto, Arial, sans-serif;
    text-align: left;
}

/* ---------- contact details ---------- */
.contact-card {
    border-radius: 12px;
    background: #fff;
    border: 1px solid rgba(35, 35, 35, 0.08);
    box-shadow: 0 6px 20px rgba(35, 35, 35, 0.06);
    overflow: hidden;
}

.contact-card__head {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: #232323;
    color: #fff;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.6rem;
    line-height: 1;
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.contact-card__head::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background: linear-gradient(90deg, #03e5b7 0%, #037ade 74%);
}

.contact-group {
    padding: 18px 20px 4px;
}

.contact-group:last-child {
    padding-bottom: 20px;
}

.contact-group__label {
    margin-bottom: 8px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(35, 35, 35, 0.5);
}

.contact-row {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 8px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid rgba(35, 35, 35, 0.08);
    color: #232323 !important;
    text-decoration: none;
    transition: border-color 0.15s, background 0.15s;
}

.contact-row:hover {
    border-color: rgba(0, 150, 136, 0.5);
    background: rgba(3, 229, 183, 0.06);
}

.contact-row__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 38px;
    height: 38px;
    border-radius: 8px;
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
}

.contact-row__text {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
}

.contact-row__label {
    font-size: 0.72rem;
    color: rgba(35, 35, 35, 0.55);
}

.contact-row__value {
    font-size: 1rem;
    font-weight: 700;
    overflow-wrap: anywhere;
}

.contact-row__go {
    color: rgba(35, 35, 35, 0.35) !important;
    transition: transform 0.15s, color 0.15s;
}

.contact-row:hover .contact-row__go {
    color: #009688 !important;
    transform: translateX(3px);
}

/* ---------- company ---------- */
.contact-aside {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.company-card {
    position: relative;
    padding: 24px 22px 20px;
    border-radius: 12px;
    background:
        radial-gradient(circle at 100% 0%, rgba(3, 229, 183, 0.22) 0%, rgba(3, 229, 183, 0) 55%),
        #232323;
    color: #fff;
    overflow: hidden;
}

.company-card::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background: linear-gradient(90deg, #03e5b7 0%, #037ade 74%);
}

.company-card__logo {
    width: 56px;
    height: 56px;
    margin-bottom: 12px;
    padding: 6px;
    border-radius: 10px;
    background: #fff;
    object-fit: contain;
}

.company-card__name {
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.8rem;
    line-height: 1.05;
    text-transform: uppercase;
}

.company-card__activity {
    margin-top: 2px;
    font-size: 0.85rem;
    color: #03e5b7;
}

.company-card__facts {
    margin: 18px 0 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.company-card__facts > div {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.company-card__facts dt {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: rgba(255, 255, 255, 0.55);
}

.company-card__facts dd {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    text-align: right;
}

/* ---------- next steps ---------- */
.contact-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.contact-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid rgba(35, 35, 35, 0.12);
    color: #232323 !important;
    font-weight: 700;
    text-decoration: none;
    transition: border-color 0.15s, background 0.15s;
}

.contact-link .v-icon {
    color: #009688 !important;
}

.contact-link:hover {
    border-color: #009688;
}

.contact-link--primary {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    border-color: transparent;
    color: #fff !important;
    box-shadow: 0 8px 20px rgba(3, 122, 222, 0.25);
}

.contact-link--primary .v-icon {
    color: #fff !important;
}

.contact-link__go {
    margin-left: auto;
    transition: transform 0.15s;
}

.contact-link:hover .contact-link__go {
    transform: translateX(3px);
}

.contact-socials {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding-top: 4px;
}

.contact-social {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #232323;
}

.contact-social .v-icon {
    color: #fff !important;
}

.contact-social:hover {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
}

@media (max-width: 900px) {
    .contact-layout {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 600px) {
    .contact-group {
        padding: 14px 12px 2px;
    }

    .contact-card__head {
        padding: 12px 14px;
        font-size: 1.35rem;
    }
}
</style>
